import { MessageOrder, SPLIT_MESSAGES_GAP_MINUTE } from "../constants";
import { useSiblingMessages } from "./useSiblingMessages";
import type { MessagingMessage } from "@/model/messaging";
import { differenceInMinutes } from "date-fns";

export const useMessageOrder = (message: MessagingMessage) => {
  const { prevMessage, nextMessage } = useSiblingMessages(message);

  return {
    order: getMessageOrder(message, prevMessage, nextMessage),
    showTimeBar:
      getMinuteDiff(prevMessage, message) >= SPLIT_MESSAGES_GAP_MINUTE,
  };
};

function getMinuteDiff(prev?: MessagingMessage, message?: MessagingMessage) {
  const prevTime = prev?.eventTime;
  const currTime = message?.eventTime;

  if (!prevTime || !currTime) {
    return SPLIT_MESSAGES_GAP_MINUTE;
  }

  return Math.abs(differenceInMinutes(currTime, prevTime));
}

function getMessageOrder(
  message: MessagingMessage,
  prevMessage?: MessagingMessage,
  nextMessage?: MessagingMessage
): MessageOrder {
  const prev = prevMessage?.participant?.externalId;
  const curr = message?.participant?.externalId;
  const next = nextMessage?.participant?.externalId;

  if (curr !== prev && curr === next) {
    return getMinuteDiff(message, nextMessage) >= SPLIT_MESSAGES_GAP_MINUTE
      ? MessageOrder.Sole
      : MessageOrder.First;
  }

  if (curr === prev && curr !== next) {
    return getMinuteDiff(message, prevMessage) >= SPLIT_MESSAGES_GAP_MINUTE
      ? MessageOrder.Sole
      : MessageOrder.Last;
  }

  if (curr === prev && curr === next) {
    if (
      getMinuteDiff(prevMessage, message) >= SPLIT_MESSAGES_GAP_MINUTE &&
      getMinuteDiff(nextMessage, message) >= SPLIT_MESSAGES_GAP_MINUTE
    ) {
      return MessageOrder.Sole;
    }
    if (getMinuteDiff(prevMessage, message) >= SPLIT_MESSAGES_GAP_MINUTE) {
      return MessageOrder.First;
    }
    if (getMinuteDiff(nextMessage, message) >= SPLIT_MESSAGES_GAP_MINUTE) {
      return MessageOrder.Last;
    }
    return MessageOrder.Middle;
  }

  return MessageOrder.Sole;
}
